import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";

const MoveFolderPopup = ({
  isVisible,
  handlerMoveModelCancel,
  handlerMoveConfirmOpen,
  selectedLanguage,
  ddlSelectedfolderName,
  folderId,
  foldersDetailsLst,
  ddlFoldername,
  shareIcon
}) => {
  if (!isVisible) return null;

  return (
    <div
      className="modal"
      id="MoveFolder"
      style={{ display: "block", backgroundColor: "#8080801c" }}>
      <div className="modal-dialog modal-dialog-centered modal-customelg">
        <div className="modal-content">
          <div className="modal-header pb-1">
            <h4
              className="d-flex align-items-center text-danger fw-bold "
              htmlFor="">
              {selectedLanguage.LstLanguageCodes.UI_Move}
            </h4>
          </div>
          <div className="modal-body  justify-content-center d-flex">
            <div className="col-sm-3">
              <p
                className="col-form-label font-w500 control res-w  text-word-break"
                style={{
                  fontSize: "15px",
                  paddingLeft: "22px",
                  paddingTop: "6px",
                }}>
                {selectedLanguage.LstLanguageCodes.UI_FolderName}
              </p>
            </div>
            <div className="col-sm-9 ">
              <Select
                className="w-100"
                id="ddlFoldername"
                value={ddlSelectedfolderName || ""}
                onChange={(e) => ddlFoldername(e)}
                displayEmpty // Allows the placeholder to be displayed when no value is selected
                renderValue={(selected) => {
                  if (selected === "") {
                    return <span>{selectedLanguage.LstLanguageCodes.UI_SelectFolder}</span>;
                  }
                  const selectedOption = foldersDetailsLst.find(
                    (option) => option.folderID === selected
                  );
                  return selectedOption
                    ? selectedOption.folderName
                    : selected;
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 240,
                      overflowY: "auto",
                      "& .MuiMenuItem-root": {
                        "&.Mui-selected": {
                          backgroundColor: "rgba(0, 123, 255, 0.2)",
                          color: "black",
                        },
                        "&.Mui-selected:hover": {
                          backgroundColor: "rgba(0, 123, 255, 0.3)",
                        },
                      },
                    },
                  },
                }}
                sx={{
                  width: "-webkit-fill-available",
                  height: "40px",
                }}>
                <MenuItem
                  value="0"
                  sx={{
                    backgroundColor:
                      ddlSelectedfolderName === ""
                        ? "rgba(0, 123, 255, 0.2)"
                        : "inherit", // Highlight when selected
                    "&.Mui-selected": {
                      backgroundColor: "rgba(0, 123, 255, 0.2)",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "rgba(0, 123, 255, 0.3)",
                    },
                    "&:hover": {
                      backgroundColor: "rgba(0, 123, 255, 0.5)",
                    },
                  }}>
                  <ListItemText primary={selectedLanguage.LstLanguageCodes.UI_SelectFolder} />
                </MenuItem>
                {/* Default Option */}
                {folderId !== 1 && folderId !== "" && (
                  <MenuItem
                    value="1"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "8px 16px",
                      backgroundColor:
                        ddlSelectedfolderName ===
                          selectedLanguage.LstLanguageCodes.UI_Default
                          ? "rgba(0, 123, 255, 0.2)"
                          : "inherit",
                      "&:hover": {
                        backgroundColor: "rgba(0, 123, 255, 0.5)", // Hover effect for options
                      },
                      "&.Mui-selected": {
                        backgroundColor: "rgba(0, 123, 255, 0.3)",
                      },
                      "&.Mui-selected:hover": {
                        backgroundColor: "rgba(0, 123, 255, 0.5)",
                      },
                    }}>
                    <ListItemText
                      primary={selectedLanguage.LstLanguageCodes.UI_Default}
                    />
                  </MenuItem>
                )}
                {/* Folder Options */}
                {foldersDetailsLst.map(
                  (option) =>
                    option.folderID !== "1" &&
                    option.folderID !== folderId && (
                      <MenuItem
                        key={option.folderID}
                        value={option.folderID}
                        className="folder-drpdwn"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "8px 16px",
                          backgroundColor:
                            option.folderName === ddlSelectedfolderName
                              ? "rgba(0, 123, 255, 0.2)"
                              : "inherit",
                          "&:hover": {
                            backgroundColor: "rgba(0, 123, 255, 0.5)",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "rgba(0, 123, 255, 0.3)",
                          },
                          "&.Mui-selected:hover": {
                            backgroundColor: "rgba(0, 123, 255, 0.5)",
                          },
                        }}>
                        <ListItemText primary={option.folderName} />
                        {option.isShared !== 0 && (
                          <ListItemIcon className="folder-share-icon">
                            <img
                              src={shareIcon}
                              alt="logo"
                              style={{ width: "25px", marginLeft: "11px" }}
                            />
                          </ListItemIcon>
                        )}
                      </MenuItem>
                    )
                )}
              </Select>
            </div>
          </div>
          <div className="d-flex justify-content-center mb-4 ">
            <button
              type="button"
              className="btn btn-danger px-4 me-1"
              data-bs-dismiss="modal"
              onClick={(e) => handlerMoveModelCancel()}>
              {selectedLanguage.LstLanguageCodes.UI_Cancel}
            </button>
            <button
              type="button"
              className="btn btn-primary px-4 ms-3"
              onClick={(e) => handlerMoveConfirmOpen()}>
              {selectedLanguage.LstLanguageCodes.UI_Move}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoveFolderPopup;
